import StorageService from 'portaltransparencia-common/libs/StorageService.js';

import * as types from './Types.js';

export function searchServidores(filter) {
  const { entidade, exercicio } = StorageService.getItem('userInfo');
  const baseFilter = `entidade=${entidade.id}&exercicio=${exercicio.id}&`;

  return ({ fetch }) => ({
    type: types.SERVIDORES_LIST,
    payload: {
      promise: fetch(`/api/servidores?${baseFilter}${filter}`)
    }
  });
}

export function loadResumoNatureza(admissaoExcepcional) {
  let url = `/api/servidores/resumonatureza?admissaoExcepcional=${admissaoExcepcional}`;

  return ({ fetch }) => ({
    type: types.SERVIDORES_RESUMO,
    payload: {
      promise: fetch(url)
    }
  });
}

export function findServidor(matricula) {
  return ({ fetch }) => ({
    type: types.SERVIDOR_DETALHE,
    payload: {
      promise: fetch(`/api/servidores/${matricula}`)
    }
  });
}

export function findServidorPorVinculo(vinculo, matricula, entidadeOrigem) {
  return ({ fetch }) => ({
    type: types.SERVIDOR_DETALHE,
    payload: {
      promise: fetch(
        `/api/servidores/${vinculo}/${matricula}/${entidadeOrigem}`
      )
    }
  });
}

export function findDadosPensao(matricula, entidadeOrigem) {
  return ({ fetch }) => ({
    type: types.SERVIDOR_DETALHE_PENSAO,
    payload: {
      promise: fetch(
        `/api/servidores/dados-pensao?matricula=${matricula}&entidadeOrigem=${entidadeOrigem}`,
        {
          ignoreStatus: 404
        }
      )
    }
  });
}

export function loadVencimentosDescontos(item, tipoEvento) {
  const url = '/api/servidores/vencimentos-descontos?';
  const matriculaParam = `matricula=${item.get('matricula')}`;
  const anoParam = `&anoCompetencia=${item.get('anoCompetencia')}`;
  const mesParam = `&mesCompetencia=${item.get('mesCompetencia')}`;
  const tipoEventoParam = `&tipoEvento=${tipoEvento}`;
  const tipoFolhaParam = `&tipoFolha=${
    item.get('tipoFolha') ? item.get('tipoFolha') : ''
  }`;
  const codigoCalculoParam = `&codigoCalculo=${
    item.get('codigoCalculo') ? item.get('codigoCalculo') : ''
  }`;
  const entidade = `&entidadeOrigem=${
    item.get('entidade') ? item.get('entidade') : 0
  }`;

  return ({ fetch }) => ({
    type: types.SERVIDOR_VENCIMENTOS_DESCONTOS,
    payload: {
      promise: fetch(
        url +
          matriculaParam +
          anoParam +
          mesParam +
          tipoEventoParam +
          tipoFolhaParam +
          codigoCalculoParam +
          entidade
      )
    }
  });
}

export function loadNaturezas() {
  const { entidade, exercicio } = StorageService.getItem('userInfo');
  const baseFilter = `entidade=${entidade.id}&exercicio=${exercicio.id}`;

  return ({ fetch }) => ({
    type: types.NATUREZAS_LIST,
    payload: {
      promise: fetch(`/api/definicoes-classes?${baseFilter}`)
    }
  });
}

export function loadNaturezasAposentadosPensionistas() {
  const { entidade, exercicio } = StorageService.getItem('userInfo');
  const baseFilter = `entidade=${entidade.id}&exercicio=${exercicio.id}&`;

  return ({ fetch }) => ({
    type: types.NATUREZAS_LIST,
    payload: {
      promise: fetch(`/api/definicoes-classes/aposentados?${baseFilter}`)
    }
  });
}

export function loadRegistrosPontos(item) {
  const url = '/api/servidores/registros-pontos?';
  const matriculaParam = `matricula=${item.get('matricula')}`;
  const anoParam = `&anoCompetencia=${item.get('anoCompetencia')}`;
  const mesParam = `&mesCompetencia=${item.get('mesCompetencia')}`;

  return ({ fetch }) => ({
    type: types.SERVIDOR_REGISTROS_PONTOS,
    payload: {
      promise: fetch(url + matriculaParam + anoParam + mesParam)
    }
  });
}

export function loadSituacoes() {
  return ({ fetch }) => ({
    type: types.SITUACOES_LIST,
    payload: {
      promise: fetch('/api/servidores/situacoes')
    }
  });
}

export function clearDetalhe() {
  return {
    type: types.CLEAR_DETALHE,
    payload: {}
  };
}

export function searchServidoresAposentados(filter) {
  const { entidade, exercicio } = StorageService.getItem('userInfo');

  const baseFilter = `entidade=${entidade.id}&exercicio=${exercicio.id}&`;

  return ({ fetch }) => ({
    type: types.SERVIDORES_LIST,
    payload: {
      promise: fetch(`/api/servidores/aposentados?${baseFilter}${filter}`)
    }
  });
}

export function searchEstagiarios(filter) {
  const { entidade, exercicio } = StorageService.getItem('userInfo');
  const baseFilter = `entidade=${entidade.id}&exercicio=${exercicio.id}&`;

  return ({ fetch }) => ({
    type: types.ESTAGIARIOS_LIST,
    payload: {
      promise: fetch(`/api/estagiarios?${baseFilter}${filter}`)
    }
  });
}

export function findEstagiario(codigo) {
  return ({ fetch }) => ({
    type: types.ESTAGIARIO_DETALHE,
    payload: {
      promise: fetch(`/api/estagiarios/${codigo}`)
    }
  });
}

export function findEstagiarioPorVinculo(vinculo, codigo) {
  return ({ fetch }) => ({
    type: types.ESTAGIARIO_DETALHE,
    payload: {
      promise: fetch(`/api/estagiarios/${vinculo}/${codigo}`)
    }
  });
}

export function searchAutonomos(filter) {
  const { entidade, exercicio } = StorageService.getItem('userInfo');
  const baseFilter = `entidade=${entidade.id}&exercicio=${exercicio.id}&`;

  return ({ fetch }) => ({
    type: types.AUTONOMOS_LIST,
    payload: {
      promise: fetch(`/api/autonomos?${baseFilter}${filter}`)
    }
  });
}

export function findAutonomo(codigo) {
  return ({ fetch }) => ({
    type: types.AUTONOMO_DETALHE,
    payload: {
      promise: fetch(`/api/autonomos/${codigo}`)
    }
  });
}

export function loadTotaisRendimentosServidores(filter) {
  const { entidade, exercicio } = StorageService.getItem('userInfo');
  const baseFilter = `entidade=${entidade.id}&exercicio=${exercicio.id}&`;

  return ({ fetch }) => ({
    type: types.TOTAIS_RENDIMENTOS_SERVIDORES_LIST,
    payload: {
      promise: fetch(
        `/api/servidores/totais-rendimentos-servidores?${baseFilter}${filter}`
      )
    }
  });
}
